import { render } from "./MobileDock.vue?vue&type=template&id=27a59acf&scoped=true"
import script from "./MobileDock.vue?vue&type=script&lang=js"
export * from "./MobileDock.vue?vue&type=script&lang=js"

import "./MobileDock.vue?vue&type=style&index=0&id=27a59acf&scoped=true&lang=css"

import exportComponent from "/home/runner/work/sirimmatrix/sirimmatrix/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27a59acf"]])

export default __exports__